module.exports = __webpack_public_path__ + "static/img/3-product-library.a782834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-product-library.png
// module id = 1336
// module chunks = 0